'use client'

import React, { createContext, Dispatch, Suspense, useContext } from "react";
import {
    User,
    WorkflowAction,
    WorkflowState,
    useWorkflow
} from "./useWorkflow";
import { Selfie } from "./Selfie";


type WorkflowContextType = {
    workflow?: WorkflowState,
    dispatch?: Dispatch<WorkflowAction>,
    startWorkflow?: () => void,
    onRegistrationSubmitted?: (user: User) => Promise<void>,
    onSelfieInstructionsAccepted?: () => void,
    onSelfieCreated?: (selfie: Selfie) => void,
    onSelfieAccepted?: () => void,
    uploadProgress?: number,
    downloadProgress?: number,
    goBackToSelfie?: () => void,
    handleVoiceRecordingFinished?: () => void,
    handleVoiceCloneCreated?: (voiceId: string) => void,
    resetWorkflow?: () => void,
    saveUserData?: () => Promise<void>,
    startCreatingViggle?: () => Promise<void>,
    viggleStatus?: 'idle' | 'creating' | 'processing' | 'completed' | 'failed',
    viggleUrl?: string,
    startNFCScanning?: () => Promise<void>,
    nfcSupported?: boolean,
    isNFCScanning?: boolean,
    nfcLoadingState?: 'idle' | 'initializing' | 'requesting-permission' | 'starting-scan' | 'scanning' | 'error',
    nfcStatusMessage?: string
}

let WorkflowContext = createContext<WorkflowContextType>({})

export default function WorkflowContextProvider({ children }: { children: React.ReactNode }) {
    let avatarWorkflow = useWorkflow();

    return <Suspense>
        <WorkflowContext.Provider value={avatarWorkflow}>
            {children}
        </WorkflowContext.Provider>
    </Suspense>
}

export function useWorkflowContext() {
    return useContext(WorkflowContext);
}
